import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    superAdmin: { id: '', name: '', email: '' },
    customer: { id: '', name: '', address: '' },
    customerAdmin: { id: '', name: '', email: '' },
    client: {id: '', name: '', address: ''}
  };
  
  const profileFormSlice = createSlice({
    name: 'profileFormSlice',
    initialState,
    reducers: {
      updateSuperAdmin: (state, action) => {
        state.superAdmin = action.payload;
      },
      updateCustomer: (state, action) => {
        state.customer = action.payload;
      },
      updateCustomerAdmin: (state, action) => {
        state.customerAdmin = action.payload;
      },
      updateClient: (state, action) => {
        state.client = action.payload
      }
    },
  });
  
  export const { updateSuperAdmin, updateCustomer, updateCustomerAdmin, updateClient } = profileFormSlice.actions;
export default profileFormSlice;